<template>
    <div class="warpper-div edit-card-wrapper">
        <div v-if="[0, 2].includes(pageType)">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
                <el-row>
                    <el-col :span="10">
                        <el-form-item :label="$t('operation.rule.ruleTemplateName') + '：'" prop="template">
                            <el-input v-model="ruleForm.template" maxlength="32"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14" v-if="$route.name !== 'checkStandardsEdit'">
                        <el-form-item :label="$t('operation.rule.industry') + '：'" prop="industryId">
                            <el-select v-model="ruleForm.industryId" filterable size="medium">
                                <el-option v-for="item in industryList" :key="item.id" :value="item.id"
                                    :label="item.industryName"></el-option>
                            </el-select>
                            <el-button size="small" type="primary" v-permission="addIndustry" @click="openModal"
                                style="margin-left: 30px;">{{
            $t('operation.rule.addIndustry')
        }}</el-button>

                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="title sys-split-line"> {{ $t('operation.rule.content') }}</div>

                <RuleTree ref="limitSet"></RuleTree>

            </el-form>

            <MyFormBtn @handleSave="handleSave"></MyFormBtn>
        </div>
        <RuleDetail :dataForm="ruleForm" @updateType="updateType" v-else></RuleDetail>
        <IndustryModal ref="addModalRef" @closeAddModal="closeModal" @deleteIndustryCallBack="deleteIndustryCallBack">
        </IndustryModal>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import RuleDetail from './components/ruleDetail.vue'
import IndustryModal from './components/industryModal.vue'
import RuleTree from './components/ruleTree.vue'
import MyFormBtn from '@/components/myFormBtn.vue'
export default {
    data() {
        return {
            industryList: [],
            monitorId: Number(Cookies.get("monitorId")),
            pageType: 0,
            ruleForm: {
                template: null,
                industryId: null,
            },
            rules: {
                template: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
                industryId: [{ required: true, message: vm.$t('common.commontip') }],
            },
        }
    },
    watch: {
        'ruleForm.template'(val) {
            let name = this.$route.name;
            if (['ruleAdd', 'ruleEdit', 'checkStandardsEdit'].includes(name) || ('ruleDetail' === name && this.pageType === 2)) {
                this.$nextTick(() => {
                    this.$refs.limitSet.updateTemplateName(val)
                })
            }
        },
    },
    components: {
        RuleDetail,
        MyFormBtn,
        RuleTree,
        IndustryModal
    },
    created() {

    },
    async mounted() {
        let name = this.$route.name;
        let { id } = this.$route.params;
        await this.checkStandardIndustryList();
        if (name === 'ruleAdd') {
            this.pageType = 0;
        } else if (['ruleEdit', 'ruleDetail', 'checkStandardsEdit', 'checkStandardsDetail'].includes(name)) {
            this.ruleForm.id = id;
            this.getRuleDetail();
            this.pageType = ['checkStandardsDetail', 'ruleDetail'].includes(name) ? 1 : 2;
        }
    },
    methods: {
        async checkStandardIndustryList() {
            let res = await this.$Http.post(this.$Api.checkStandardIndustryList + '/' + this.monitorId);
            if (res.success) {
                this.industryList = res.result;
            }
        },
        getRuleDetail() {
            let result = JSON.parse(sessionStorage.getItem('row') || '{}');
            this.ruleForm.template = result.template;
            if (result.industryId) {
                let arrayList = this.industryList.filter(item => {
                    return item.id == result.industryId
                });
                if (arrayList.length === 0) {
                    this.ruleForm.industryId = null;
                } else {
                    this.ruleForm.industryId = result.industryId;
                    this.ruleForm.industryName = result.industryName;
                }
            }
        },
        updateType() {
            this.pageType = 2;
        },
        goBackClick() {
            this.$router.go(-1);
        },
        handleSave() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                    let data = this.$refs.limitSet.tableData[0];
                    data.name = this.ruleForm.template;
                    if (this.ruleForm.industryId) {
                        data.industryId = this.ruleForm.industryId;
                    }
                    let url = this.$Api.templateAddNodes + '/' + this.monitorId
                    if (this.ruleForm.id) {
                        url = this.$Api.templateEditNodes + '/' + this.monitorId;
                    } else {
                        data.id = null;
                    }
                    this.$Http.post(url, data).then(res => {
                        if (res.success) {
                            this.$message.success(vm.$t('common.successful'));
                            this.goBackClick();
                        }
                    });

                }
            });
        },
        openModal() {
            this.$refs.addModalRef.open(this.monitorId, this.industryList);
        },
        closeModal() {
            this.$refs.addModalRef.close();
            this.checkStandardIndustryList();
        },
        async deleteIndustryCallBack(id) {
            await this.checkStandardIndustryList();
            if (this.ruleForm.industryId === id) {
                this.ruleForm.industryId = null;
            }
        },
    },
}
</script>

<style scoped lang="scss">
.warpper-div {
    position: relative;
}

.warpper-div .el-input,
.warpper-div .el-input__inner {
    width: 232px;
}
</style>

<style lang="scss">
.warpper-div {
    .el-form-item {
        margin-bottom: 20px !important;
    }
}
</style>